<template>
    <button type="button" class="secondary-btn" :disabled="disabled" @click="$emit('click')">
        <span class="btn-content">

            <!-- ICONO -->
            <SmartphoneNfc class="icon" />

            <!-- TEXTO -->
            <span class="label">
                <slot />
            </span>

        </span>
    </button>
</template>

<script>
import { SmartphoneNfc } from 'lucide-vue-next'

export default {
    name: 'SecondaryButton',
    components: {
        SmartphoneNfc
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style scoped>
.secondary-btn {
    width: 100%;
    height: 42px;
    border-radius: 12px;

    font-size: 13px;
    font-weight: 600;
    color: #0b3c5d;

    background: linear-gradient(135deg, #e6f7ff, #f0fbff);
    border: 1px solid #cfe9f3;

    display: flex;
    align-items: center;
    justify-content: center;

    transition: all 0.2s ease;
    cursor: pointer;
}

/* CONTENIDO */
.btn-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* ICONO */
.icon {
    width: 16px;
    height: 16px;
}

/* TEXTO */
.label {
    letter-spacing: 0.3px;
}

/* HOVER */
.secondary-btn:hover:not(:disabled) {
    background: linear-gradient(135deg, #d9f4ff, #e6faff);
    border-color: #36e0f7;
    box-shadow: 0 6px 18px rgba(54, 224, 247, 0.2);
    transform: translateY(-1px);
}

/* ACTIVE */
.secondary-btn:active:not(:disabled) {
    transform: scale(0.98);
    box-shadow: none;
}

/* FOCUS */
.secondary-btn:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(54, 224, 247, 0.25);
}

/* DISABLED */
.secondary-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: none;
}
</style>